import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRoFlag = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_218_3622)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M16.1741 0.745367C14.8741 0.26307 13.4681 -0.000976556 12.0002 -0.000976556C10.5324 -0.00102343 9.12633 0.26307 7.82635 0.745367L6.78287 11.999L7.82635 23.2526C9.12629 23.735 10.5323 23.999 12.0002 23.999C13.468 23.999 14.8741 23.735 16.1741 23.2526L17.2176 11.999L16.1741 0.745367Z",
				fill: "#FFDA44"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M23.9997 11.9996C23.9997 6.84005 20.7432 2.44144 16.1736 0.745972V23.2533C20.7432 21.5576 23.9997 17.1592 23.9997 11.9996Z",
				fill: "#D80027"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M0.000152588 11.9995C0.000152588 17.1592 3.25665 21.5576 7.82617 23.2532L7.82622 0.745972C3.25665 2.44144 0.000152588 6.83991 0.000152588 11.9995Z",
				fill: "#0052B4"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_218_3622",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "white"
		})
	}) })]
});
export default SvgRoFlag;
